import SockJS from 'sockjs-client'
import Stomp from 'stompjs'
class MySocket {
  constructor(obj) {
    this.socketUrl = obj.url
    this.socket = new SockJS(obj.url) // 建立连接对象
    this.stompClient = Stomp.over(this.socket)
    this.connectHeaders = obj.connectHeaders || {}
    this.subscribeUrl = obj.subscribeUrl // 订阅地址
    this.receive = obj.receive // 订阅回调函数

    this.socketTimer = null
    this.heartBeat = {}
    this.heartBeat.wait = obj.heartBeat?.wait || 5000

    this.connectTimer = null // 连接定时器

    this.retryMaxCount = 3 // 最多重试次数
    this.retryInterval = 5000 // 重试间隔（ms）
    this.crrRetryCount = 0 // 当前重试次数

    this.subscriptions = [] // 订阅列表
    this.initSocket(obj)
  }

  static connectTab = '' // 连接标识

  // 初始socket
  initSocket(obj) {
    this.initConnect()
  }

  // 单连接
  doConnect(headers) {
    console.log('doConnect', headers)
    return new Promise((resolve, reject) => {
      this.stompClient.connect(
        headers || {}, // 订阅地址
        () => {
          console.log('连接成功',)
          this.connectTimer && clearInterval(this.connectTimer)
          resolve()
        },
        err => {
          console.log('已断开连接...')
          reject(err)
          // this.startConnectTimer(headers)
        }
      )
    })
  }

  // 单订阅
  doSubscribe(url, success) {
    this.subscribeUrl = url
    let subscription = this.stompClient.subscribe(
      url, // 订阅地址
      (msg) => {
        console.log('订阅成功')
        success(msg)
      },
    )
    this.subscriptions.push(subscription)
  }

  // 取消订阅
  doUnSubscribes(){
    this.subscriptions.forEach(item=>{
      if(item){
        item.unsubscribe()
      }
    })
    this.subscriptions = []
  }

  // 开始连接，并订阅服务端消息
  initConnect() {
    this.stompClient.connect(this.connectHeaders, () => {
      if (!this.subscribeUrl) return
      this.stompClient.subscribe(
        this.subscribeUrl, // 订阅地址
        (msg) => {
          this.receive(msg)
        },
      )
    }, (err) => {
      console.log(err)
      this.connectTab = 'fail'
    })
  }

  startConnectTimer(headers) {
    if (this.crrRetryCount >= this.retryMaxCount) {
      this.crrRetryCount = 0 // 重置次数
      return
    }
    setTimeout(() => {
      console.log('开始重新连接_startConnectTimer')
      this.socket = new SockJS(this.socketUrl) // 建立连接对象
      this.stompClient = Stomp.over(this.socket)
      this.doConnect(headers).then(res => {
        console.log('then_82', res)
      })
      this.crrRetryCount++
    }, this.retryInterval)
  }

  // 关闭socket倒计时
  clearSocketInterval() {
    clearInterval(this.socketTimer)
  }
}

export {
  MySocket
}
